<nav-bar></nav-bar>
<div class="content-wrap" *ngIf="!loginWidget.isLoggedIn()" id="nmdp-login-container"></div>
<div class="content-wrap" *ngIf="loginWidget.isLoggedIn()">
    <router-outlet></router-outlet>
</div>
<footer-component></footer-component>
